import * as betprofessor from './Upcoming.styles.betprofessor';
import * as betroyale from './Upcoming.styles.betroyale';
import * as fiestabet from './Upcoming.styles.fiestabet';
import * as goldenrush from './Upcoming.styles.goldenrush';
import * as juicybet from './Upcoming.styles.juicybet';
import * as puntcity from './Upcoming.styles.puntcity';
import * as puntgenie from './Upcoming.styles.puntgenie';
import * as questbet from './Upcoming.styles.questbet';
import * as sterlingparker from './Upcoming.styles.sterlingparker';
import * as vikingbet from './Upcoming.styles.vikingbet';
import * as volcanobet from './Upcoming.styles.volcanobet';
import * as forsport from './Upcoming.styles.forsport';
import * as junglebet from './Upcoming.styles.junglebet';
import * as betstride from './Upcoming.styles.betstride';
import * as sugarcastle from './Upcoming.styles.sugarcastle';
import * as oldgill from './Upcoming.styles.oldgill';
import * as buffalobet from './Upcoming.styles.buffalobet';
import * as titanbet from './Upcoming.styles.titanbet';
import * as bet777 from './Upcoming.styles.bet777';
import * as goldenbet888 from './Upcoming.styles.goldenbet888';
import * as gigabet from './Upcoming.styles.gigabet';
import * as slambet from './Upcoming.styles.slambet';
import * as chromabet from './Upcoming.styles.chromabet';
import * as templebet from './Upcoming.styles.templebet';
import * as hyperbet from './Upcoming.styles.hyperbet';
import * as bet575 from './Upcoming.styles.bet575';
import * as epicodds from './Upcoming.styles.epicodds';
import * as pyramidbet from './Upcoming.styles.pyramidbet';
import * as magnumbet from './Upcoming.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  forsport,
  junglebet,
  betstride,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  bet777,
  gigabet,
  slambet,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
